<template>
	<div>
<el-dialog :visible.sync="showmodal" width="35%" @close="$emit('close-modal')">
<div class="text-center modals-wrapper px-5">
<img src="@/assets/images/icons/putonhold-finalmodal-icon.png" class=" mx-auto">
<p class="mt-4 w-11/12 text-left">By confirming to put on-hold below, your assigned shipment would be put on hold. </p>
<div class="mt-5 text-left">
<p class="text-md">Please state the reason why?</p>
<textarea class="rounded-sm w-full  p-3 border border-gray-100 block" rows="2" placeholder="Enter your reason(s)..." type="textarea" v-model="putonholdreason"></textarea>                 
</div>
<div class="flex flex-wrap justify-around">
    <p @click="$emit('close-modal')" class="mt-12 rounded-md cursor-pointer p-3 w-1/2 text-left px-4 text-lg underline">Go back</p>
    <button v-loading="loading" @click="$emit('keep-hold')" class="mt-12 rounded-md p-1 px-5 text-md" style="color:#10233E;">Confirm</button>    
</div>


</div>
</el-dialog>
	</div>
</template>
<script type="text/javascript">
export default{
	props : {
		showmodal : Boolean,
		consolidationId : String
	},
	data() {
		return {
			putonholdreason : "",
			loading : false
		}
	},
	methods: {
		async updateStatus(){

			let request = {
				status : "on-hold",
				userId : this.$store.state.authentication.userId
			}
			this.loading = true

			try{
				await this.$_modifyDispatch(this.consolidationId, request)
				
				this.loading = false

				this.$emit('refetch-dispatch')
				this.$emit('close-modal')

			}catch(error){
				this.loading = false
				this.handleError(error)
			}
				
		}
	}
}
</script>
<style lang="scss">
.modals-wrapper{
	button{
		background-color : #FCC210;
		color : #10233E;
		font-weight : 600;
	}
	input {

	}
}
</style>